<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row justify="center">
        <v-col cols="12">
          <parametros-validacao ref="valMcpseParametros" />
        </v-col>
        <v-col cols="12">
          <v-btn
            id="btn-save-validacao-mcpse"
            color="green"
            min-width="100"
            style="float: right"
            :disabled="invalid"
            :loading="loading"
            @click="salvarValidacao()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import ValidacaoService from '@/services/ValidacaoAtributosMcpseService.js';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      ParametrosValidacao: () => import('@/components/validacaoAtributosMcpse/ParametrosValidacao.vue')
    },

    mixins: [tourMixins],

    data() {
      return {
        loading: false,
        arrTour: [
          {
            element: '#titulo-validacao-mcpse',
            intro: 'Aqui você poderá inserir um nome para sua validação de atributos MCPSE.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#tipo-validacao-mcpse',
            intro: 'Aqui você poderá selecionar o tipo de base para validação "Física ou Contábil".',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#origem-validacao-mcpse',
            intro: 'Aqui você poderá selecionar a origem dos dados a serem validados "Consulta ou Arquivo".',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#btn-save-validacao-mcpse',
            intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar sua validação de atributos MCPSE.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },

    mounted() {
      this.iniciarTourPagina();
    },

    methods: {
      salvarValidacao() {
        this.loading = true;

        const data = this.$refs.valMcpseParametros.exportData();

        ValidacaoService.salvarValidacao(data)
          .then(() => {
            this.$router.push({ name: 'Validacao de Atributos MCPSE Historico' });
            this.$toast.success('Validação salva com sucesso.', '', {
              position: 'topRight',
              timeout: 3000
            });
          })
          .catch((err) => {
            console.log('Erro ao salvar validacao: ', err);
            this.$toast.error('Erro ao salvar validação.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>